import { useState } from 'react';
import { Button } from "react-bootstrap";
//import { getAuth,sendPasswordResetEmail } from 'firebase/auth';
//import { auth } from '../firebase';
import styles from './ForgottenPassword.css';
import { useNavigate, Link } from 'react-router-dom';
import { AiFillEye } from "react-icons/ai";
import { AiFillEyeInvisible } from "react-icons/ai";
//import { getFirebaseApp } from '../utils/firebaseHelper'
//import { ref, child, set, getDatabase } from 'firebase/database'
import Konsensus_Constants from '../constants/index.js';
import axios from "axios";

export default function ForgottenPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  const handleForgottenPassword = async () => {
      const formData = new URLSearchParams();
      formData.append('email', email);
      formData.append('url', Konsensus_Constants.APP_URL);
      let xcsrftoken = '';
      try {
        const response = await fetch(Konsensus_Constants.FORUM_URL+'/api/forgot-password', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: email, url: Konsensus_Constants.APP_URL }),
        });

        // You can check response.ok and optionally parse the HTML for a success message
        if (response.ok) {
          alert('If the email is registered, a reset link was sent.');
        } else {
          console.log(JSON.stringify(response));
          alert('There was an error processing your request.');
        }
      } catch (error) {
        alert('Network error, please try again.');
      }
  };

  return (
  <div style={{
                height: '100%',
                display: 'grid',
                placeItems: 'center',
              }}>
    <div style={{
                  flex: 1,
                  align: 'center',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginHorizontal: 22,
                }}>
      <img
         src={require('../assets/images/logo.png')}
         style={{
            height: 240,
            width: 340,
            marginBottom: 12,
         }}
      />
      <h2>Forgotten Password</h2>
      <div><input placeholder="Email" className="input-rounded" type="email"
        onChange={e => setEmail(e.target.value)} /></div>
      <Button onClick={handleForgottenPassword} style={{backgroundColor: "#00aaaf", borderColor: "#00aaaf"}} className="input-rounded">Reset password</Button>
      <p>Already have an account? <Link to="/">Login</Link></p>
    </div>
  </div>
  );
}